import React from 'react';
import {
    Box,
    Typography,
    Container,
    CircularProgress,
    Button,
    Divider,
    Paper
} from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import SpinnerImage from '../../../assets/images/DQProImages/dq-spinner.120f3d39.png'

const useStyles = makeStyles((theme) => ({
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    rubricContainer: {
        display: 'flex',
        backgroundColor: '#f4f2f3',
        borderRadius: '15px !important',
        padding: '10px 18px',
        width: '77vh',
        // maxHeight: '334px',
    },
    rawRubric: {
        '& $rubricScores': {
            justifyContent: 'flex-start !important',
            '& span': {
                marginTop: '-5px',
            }
        }
    },
    rubricScores: {
        display: 'flex',
        width: '50px',
        textAlign: 'right',
        paddingRight: '10px',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        fontFamily: "'Lemon/Milk'",
        fontSize: '1.3rem',
        '& span': {
            width: '40px',
            marginBottom: '-15px',
        }
    },
    rubricRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    rubricContent: {
        textAlign: 'left',
        width: '100%',
    },
    rubricItem: {
        display: 'flex',
        padding: '5px 10px',
        borderLeft: '12px solid',
        marginBottom: '2px',
        '& span': {
            display: 'flex',
            alignItems: 'center',
            fontWeight: '800',
            fontSize: '1.3rem',
            width: '30%',
            lineHeight: '20px',
        },
        '& div': {
            paddingLeft: '5px',
            textAlign: 'justify',
            fontSize: '1rem',
            width: '100%',
        }
    },
    scoreRubric: {
        '& img': {
            minHeight: '180px',
            height: '33vh',
            width: '70vh',
        }
    },
    resultButtonContainer: {
        justifyContent: 'center',
        display: 'flex',
        width: '115vh',
        margin: '0 auto',
        marginTop: '3vh',
        alignItems: 'center',
    },
    moreInfoLink: {
        fontFamily: '"Source Sans Pro", "Helvetica Neue"',
        fontWeight: 500,
        width: '100vh',
        fontSize: '1.2rem',
        '& a': {
            color: '#ee6629',
            fontStyle: 'normal',
        }
    },
    disclaimer: {
        width: '70vh',
        padding: '1vh 0 1vh',
        fontFamily: '"Source Sans Pro", "Helvetica Neue"',
        fontSize: '0.7rem',
        fontStyle: 'italic',
        color: 'gray',
    },
    scoreContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(4),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        }
    },
    scoreDisplay: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    rubricExcellent: {
        borderLeftColor: '#3cc6f3',
        '& span': { color: '#3cc6f3' }
    },
    rubricAboveAvg: {
        borderLeftColor: '#f5a335',
        '& span': { color: '#f5a335' }
    },
    rubricBelowAvg: {
        borderLeftColor: '#838383',
        '& span': { color: '#838383' }
    },
    rubricReqAtt: {
        borderLeftColor: '#ff00c6',
        '& span': { color: '#ff00c6' }
    },
    scoreCircleContainer: {
        position: 'relative',
        width: '200px',
        height: '200px',
        marginBottom: theme.spacing(2),
    },
    scoreCircleImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    scoreTextContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainScore: {
        fontSize: '3rem',
        fontWeight: 'bold',
        lineHeight: 1,
    },
    decimalScore: {
        fontSize: '1.5rem',
        marginLeft: '0.2rem',
    },
}));

const DQProAssessmentResult = () => {
    const classes = useStyles();
    const score = 85.50;
    const loading = false;

    return (
        <Box className="quiz-result-container">
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Container maxWidth="lg" sx={{ py: 4 }}>
                        {/* Score Section */}
                        <Box textAlign="center" mb={4}>
                            <Typography variant="h1" className={classes.title} gutterBottom>
                                REQUIRES ATTENTION!
                            </Typography>
                        </Box>

                        <Box className={classes.scoreContainer}>
                            {/* Score Circle */}
                            <Box className={classes.scoreDisplay}>
                                <Box className={classes.scoreCircleContainer}>
                                    {/* Replace this src with your actual image path */}
                                    <img
                                        src={SpinnerImage}
                                        alt="Score circle"
                                        className={classes.scoreCircleImage}
                                    />
                                    <Box className={classes.scoreTextContainer}>
                                        <Typography variant="h2" className={classes.mainScore}>
                                            {score.toFixed(0)}
                                            <Typography component="span" className={classes.decimalScore}>
                                                .{score.toFixed(2).split('.')[1]}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant="h5" sx={{ mt: 2 }}>
                                    Your score is in the <span style={{color:'#ff00c6'}}>85th percentile</span>.
                                </Typography>
                            </Box>

                        <Paper elevation={3} className={`${classes.rubricContainer} ${classes.rawRubric}`}>
                            <Box className={classes.rubricContent}>
                                {/* Excellent */}
                                <Box className={`${classes.rubricRow} ${classes.rubricExcellent}`}>
                                    <Box className={classes.rubricScores}>
                                        <Typography>115</Typography>
                                    </Box>
                                    <Box className={`${classes.rubricItem} ${classes.rubricExcellent}`}>
                                        <Typography component="span">Excellent</Typography>
                                        <Box>
                                            <Typography>You are ready to use technology.You understand how to use technology safely. Continue building your digital skills to thrive.</Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Above Average */}
                                <Box className={`${classes.rubricRow} ${classes.rubricAboveAvg}`}>
                                    <Box className={classes.rubricScores}>
                                        <Typography>100</Typography>
                                    </Box>
                                    <Box className={`${classes.rubricItem} ${classes.rubricAboveAvg}`}>                                            <Typography component="span">Above Average</Typography>
                                        <Box>
                                            <Typography>Your score is above average compared to the global average.We recommend that you keep building a comprehensive set of digital citizenship skills.</Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Below Average */}
                                <Box className={`${classes.rubricRow} ${classes.rubricBelowAvg}`}>
                                    <Box className={classes.rubricScores} style={{ width: '72px',}}>
                                        <Typography>85</Typography>
                                    </Box>
                                    <Box className={`${classes.rubricItem} ${classes.rubricBelowAvg}`}>
                                        <Typography component="span">Below Average</Typography>
                                        <Box>
                                            <Typography>Your score is less than average compared to the global average.We recommend that you enhance your digital citizenship skills if you are actively using technology.</Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Require Attention */}
                                <Box className={`${classes.rubricRow} ${classes.rubricReqAtt}`}>
                                    <Box className={classes.rubricScores} style={{ width: '61px',}}>
                                        <Typography></Typography>
                                    </Box>
                                    <Box className={`${classes.rubricItem} ${classes.rubricReqAtt}`}>
                                        <Typography component="span">Require Attention</Typography>
                                        <Box>
                                            <Typography>You may potentially be exposed to one or more cyber-risks.We recommend that you check your cyber-risk exposure level.</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                        </Box>

                        <Box className={classes.resultButtonContainer} mt={4}>
                            <Button
                                variant="contained"
                                size="large"
                                sx={{
                                    backgroundColor: '#ff6468',
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                    fontSize: '19px',
                                    borderRadius: '20px',
                                    boxShadow: 'none',
                                    px: 4,
                                    mb:4,
                                    '&:hover': {
                                        backgroundColor: '#ff6468',
                                    },
                                }}
                            >
                                Done
                            </Button>
                        </Box>

                    </Container>
                </>
            )}
        </Box>
    );
};

export default DQProAssessmentResult;